<template>
  <div>
    <button
      v-if="!dashboard && !hideAddButton"
      :disabled="!hasAccessAdd"
      class="bttn bttn--sm bttn--orange"
      @click="openModal"
    >
      {{ $t("teams.add_new_team", "Add new team") }}
    </button>
    <b-modal id="team-form" size="xl" @hidden="clearData">
      <div slot="modal-header">
        <h2>
          {{
            edit ? $t("teams.edit_team", "Edit team") : $t("teams.add_team_modal", "Add new team")
          }}
        </h2>
        <div class="modal-header__hide" @click="modalClose">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>

      <div slot="modal-footer">
        <button type="button" class="bttn bttn--lg bttn--blue" @click="modalClose" name="button">
          {{ $t("teams.close") }}
        </button>
        <button
          form="team-add"
          type="submit"
          :disabled="sending"
          :class="sending ? 'disabled bttn bttn--lg bttn--orange' : 'bttn bttn--lg bttn--orange'"
        >
          <b-spinner v-if="sending" small class="mx-1" />
          {{ $t("teams.save") }}
        </button>
      </div>

      <form
        id="team-add"
        ref="TeamAdd"
        action
        class
        @submit.prevent="saveForm"
        @click="hidePickerColor"
      >
        <error v-if="errors" :errors="errors"></error>

        <div class="form-block">
          <b-tabs
            content-class="mt-3"
            @activate-tab="onActivateTab"
            active-nav-item-class="bttn--blue"
          >
            <b-tab :title="$t('teams.details_tab', 'Details')">
              <div class="row">
                <div class="col-12 col-lg-3">
                  <div class="matcher-card__img">
                    <div class="matcher-img">
                      <label v-if="!displayTeamImage" @click="changeImage()">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                          />
                        </svg>
                        {{ $t("teams.upload_image") }}
                      </label>

                      <div v-if="displayTeamImage" class="matcher-img__loaded">
                        <div class="image-wrapper">
                          <img :src="displayTeamImage" alt />
                        </div>
                        <div class="matcher-img__action matcher-img__delete" @click="deleteImage()">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                            />
                            <path d="M0 0h24v24H0z" fill="none" />
                          </svg>
                        </div>
                        <label
                          class="matcher-img__action matcher-img__change"
                          @click="changeImage()"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                              d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                            />
                          </svg>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-9">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group form-unit">
                        <label class="form-unit__label form-unit__label--required" for>{{
                          $t("teams.name", "Team Name")
                        }}</label>
                        <input
                          type="text"
                          class="form-control form-unit__input"
                          v-model="teamData.data.attributes.name"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="form-group form-unit form-unit--addon-right">
                        <label class="form-unit__label">{{ $t("teams.goal") }}</label>
                        <div class="form-unit__addon-wrap">
                          <input
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            class="form-control form-unit__input"
                            :placeholder="$t('teams.goal')"
                            v-model.number="displayGoalCurrencyAmountModel"
                            required
                          />
                          <div class="form-unit__addon-icon form-unit__addon-icon--right px-1">
                            <b-dropdown class="dropdown">
                              <template #button-content>
                                <span class="text-uppercase">
                                  {{ displayGoalCurrencyModel }}
                                </span>
                              </template>
                              <b-dropdown-item
                                v-for="c in currencies"
                                :key="c"
                                @click="updateCurrency(c)"
                              >
                                {{ $t(`dashboard.currency_code_${c}`, c) }}
                              </b-dropdown-item>
                            </b-dropdown>
                          </div>
                          <div v-if="currencyRate !== 1" class="convert-amount">
                            <label> {{ ccy }} {{ goalInCampaignCurrency }} </label>
                          </div>
                        </div>
                        <b-form-text class="font-weight-bold" id="internal-goal-help">
                          <b-icon-question-circle-fill></b-icon-question-circle-fill>
                          <template v-if="pgMultiplier > 1 && displayGoalCurrencyAmountModel !== 0">
                            {{
                              $t(
                                "dashboard.goal_help_multiplier",
                                `With the current campaign matching setting of ${pgMultiplier}x, the amount to be collected is ${displayGoalCurrencyAmountModel} ÷ ${pgMultiplier} = ${Math.round(
                                  displayGoalCurrencyAmountModel / pgMultiplier
                                )}`
                              )
                            }}
                          </template>
                          <template v-else>
                            {{
                              $t(
                                "dashboard.goal_help",
                                "this amount should be your goal AFTER MATCH"
                              )
                            }}
                          </template>
                        </b-form-text>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="form-group form-unit form-unit--addon">
                        <label class="form-unit__label">
                          {{ $t("teams.bonus_goal", "Bonus goal") }}
                        </label>
                        <div class="form-unit__addon-wrap">
                          <div class="form-unit__addon-icon no-pointer">
                            {{ displayGoalCurrencyModel }}
                          </div>
                          <input
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            class="form-control form-unit__input"
                            :placeholder="$t('teams.bonus_goal', 'Bonus Goal')"
                            v-model.number="displayBonusGoalCurrencyAmountModel"
                          />
                          <div v-if="currencyRate !== 1" class="convert-amount">
                            <label> {{ ccy }} {{ bonusGoalInCampaignCurrency }} </label>
                          </div>
                        </div>
                        <b-form-text class="font-weight-bold" id="internal-goal-help">
                          <b-icon-question-circle-fill></b-icon-question-circle-fill>
                          <template
                            v-if="bgMultiplier > 1 && displayBonusGoalCurrencyAmountModel !== 0"
                          >
                            {{
                              $t(
                                "dashboard.bonus_goal_help_multiplier",
                                `With the current campaign matching setting of ${bgMultiplier}x, the amount to be collected is ${displayBonusGoalCurrencyAmountModel} ÷ ${bgMultiplier} = ${Math.round(
                                  displayBonusGoalCurrencyAmountModel / bgMultiplier
                                )}`
                              )
                            }}
                          </template>
                          <template v-else>
                            {{
                              $t(
                                "dashboard.bonus_goal_help",
                                "bonus goal should be more then original one"
                              )
                            }}
                          </template>
                        </b-form-text>
                      </div>
                    </div>

                    <!-- rate imput to allow set custom rate -->
                    <div v-if="ccy != displayGoalCurrencyModel" class="col-12 col-md-6">
                      <div class="form-group form-unit form-unit--addon">
                        <label class="form-unit__label">
                          {{ $t("teams.currency_rate", "Currency Rate") }}
                        </label>
                        <div class="form-unit__addon-wrap">
                          <div class="form-unit__addon-icon no-pointer">
                            {{ ccy }}
                          </div>
                          <input
                            type="text"
                            inputmode="numeric"
                            class="form-control form-unit__input"
                            :placeholder="$t('teams.currency_rate', 'Currency Rate')"
                            v-model.number="currencyRate"
                          />
                        </div>
                      </div>
                    </div>

                    <team-goal-categories
                      v-model="teamData.data.attributes.goal_categories"
                      :goal.sync="displayGoalCurrencyAmountModel"
                    />
                    <div class="wrapper-options">
                      <button
                        type="button"
                        @click="showOptionaly = !showOptionaly"
                        class="show-hide-bttn"
                        name="button"
                      >
                        {{
                          !showOptionaly
                            ? $t(
                                "dashboard.add_team_show_optionaly",
                                "Show additional goal options"
                              )
                            : $t(
                                "dashboard.add_team_hide_optionaly",
                                "Hide additional goal options"
                              )
                        }}
                        <i
                          :class="!showOptionaly ? 'fa fa-angle-down' : 'fa fa-angle-up'"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                    <div class="col-12 col-md-6" v-if="showOptionaly">
                      <div class="form-group form-unit form-unit--addon">
                        <label class="form-unit__label">{{
                          $t("teams.internal_goal_text", "Goal")
                        }}</label>
                        <div class="form-unit__addon-wrap">
                          <div class="form-unit__addon-icon no-pointer">
                            {{ displayGoalCurrencyModel }}
                          </div>
                          <input
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            class="form-control form-unit__input"
                            :placeholder="$t('teams.goal')"
                            v-model.number="displayInternalGoalCurrencyAmountModel"
                            aria-describedby="internal-goal-help"
                          />
                          <div v-if="currencyRate !== 1" class="convert-amount">
                            <label> {{ ccy }} {{ internalGoalInCampaignCurrency }} </label>
                          </div>
                        </div>
                        <b-form-text class="font-weight-bold" id="internal-goal-help">
                          <b-icon-question-circle-fill></b-icon-question-circle-fill>
                          {{
                            $t(
                              "dashboard.internal_goal_help",
                              "Internal expectations of the team performance, not visible to the public"
                            )
                          }}
                        </b-form-text>
                      </div>
                    </div>
                    <div class="col-12 col-md-6" v-if="showOptionaly">
                      <div class="form-group form-unit form-unit--addon">
                        <label class="form-unit__label">{{
                          $t("teams.gonor_goal_text", "Donor Count Goal")
                        }}</label>
                        <div class="form-unit__addon-wrap">
                          <input
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            class="form-control form-unit__input"
                            :placeholder="$t('teams.goal', 'Donor goal')"
                            v-model.number="teamData.data.attributes.donor_goal"
                            aria-describedby="internal-goal-help"
                          />
                        </div>
                        <b-form-text class="font-weight-bold" id="internal-goal-help">
                          <b-icon-question-circle-fill></b-icon-question-circle-fill>
                          {{
                            $t(
                              "dashboard.gonor_goal_help",
                              "shown on the campaign page by meta. please set a goal for the number of donors you would like to reach."
                            )
                          }}
                        </b-form-text>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group form-unit form-unit--addon">
                        <label class="form-unit__label form-unit__label--required">{{
                          $t("teams.slug")
                        }}</label>
                        <div class="form-unit__addon-wrap">
                          <div class="form-unit__addon-icon form-unit__addon-wide no-pointer">
                            {{ domain }}
                          </div>
                          <input
                            type="text"
                            class="form-control form-unit__input form-unit__input--slug"
                            v-model="teamData.data.attributes.slug"
                            @input="onSlugInput"
                            required
                          />
                        </div>
                        <a class="form-unit__copy-link" @click="copySlug">
                          {{ teamLink }}
                        </a>
                        <div v-if="!edit" class="mt-2">
                          <button
                            type="button"
                            class="bttn bttn--sm bttn--bordered-blue"
                            @click="generateRandomSlug"
                          >
                            {{ $t("teams.generate_random_slug", "Generate random number") }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="hasAccessAddCustomLinkToTeam" class="col-12">
                      <div class="form-group form-unit">
                        <label class="form-unit__label form-unit__label">{{
                          $t("teams.custom_link", "Custom link")
                        }}</label>
                        <div class="form-unit__input">
                          <input
                            type="text"
                            class="form-control form-unit__input"
                            v-model="teamData.data.attributes.custom_link"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- PARENT TEAM FIELD -->
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group form-unit form-unit--multiselect">
                            <label class="form-unit__label">
                              {{ $t("teams.parent_team") }}
                              <span
                                v-b-tooltip.hover
                                :title="
                                  $t('teams.parent_team_tooltip_title', 'Community will be created')
                                "
                              >
                                <b-icon-question-circle-fill variant="info" />
                              </span>
                            </label>
                            <multiselect-search
                              v-model="parentTeamId"
                              :open-prefetch="true"
                              :search-url="getTeamSearchUrl"
                              :search-options="teamSearchOptions"
                              aria-describedby="parent-team-help"
                            >
                              <template #no-options>
                                {{
                                  $t(
                                    "dashboard.team_search_no_options",
                                    "Please enter 1 or more characters"
                                  )
                                }}
                              </template>
                              <template #no-more-infinite>
                                {{ $t("dashboard.team_search_no_more", "No more teams") }}
                              </template>
                            </multiselect-search>

                            <b-form-text class="font-weight-bold" id="parent-team-help">
                              <b-icon-question-circle-fill></b-icon-question-circle-fill>
                              {{ $t("dashboard.parent_team.help") }}
                            </b-form-text>
                          </div>
                        </div>
                        <div class="col-12" v-show="multiple_team_parent">
                          <div class="form-group form-unit form-unit--multiselect">
                            <label class="form-unit__label">{{
                              $t("dashboard.parent_team_2")
                            }}</label>
                            <multiselect-search
                              v-model="parentTeamId2"
                              :open-prefetch="true"
                              :search-url="getTeamSearchUrl"
                              :search-options="teamSearchOptions2"
                              aria-describedby="parent-team-help"
                            >
                              <template #no-options>
                                {{
                                  $t(
                                    "dashboard.team_search_no_options",
                                    "Please enter 1 or more characters"
                                  )
                                }}
                              </template>
                              <template #no-more-infinite>
                                {{ $t("dashboard.team_search_no_more", "No more teams") }}
                              </template>
                            </multiselect-search>
                            <b-form-text class="font-weight-bold" id="parent-team-help">
                              <b-icon-question-circle-fill></b-icon-question-circle-fill>
                              {{ $t("dashboard.parent_team.help") }}
                            </b-form-text>
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                    <div class="col-12">
                      <div class="form-group form-unit">
                        <label class="form-unit__label">{{ $t("teams.leader_name") }}</label>
                        <div
                          class="float-label"
                          :class="{ 'is-active': teamData.data.attributes.leader_name.length }"
                        >
                          <input
                            type="text"
                            class="form-control form-unit__input"
                            v-model="teamData.data.attributes.leader_name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="form-group form-unit">
                        <label class="form-unit__label">{{ $t("teams.leader_email") }}</label>
                        <input
                          type="text"
                          class="form-control form-unit__input"
                          v-model="teamData.data.attributes.leader_email"
                          aria-describedby="leader-email-help"
                        />
                      </div>
                      <b-form-text class="font-weight-bold" id="leader-email-help">
                        <b-icon-question-circle-fill></b-icon-question-circle-fill>
                        {{
                          $t(
                            "dashboard.group.help",
                            "This is for an optional feature to put teams in groups (Unidy template only). To use this, please contact your Campaign Manager or Tech Support"
                          )
                        }}
                      </b-form-text>
                      <br />
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="form-group form-unit">
                        <label class="form-unit__label">
                          <span>
                            {{ $t("teams.phone") }}
                          </span>
                          <b-icon
                            icon="info-circle"
                            v-b-popover.hover.top="$t('teams.phone_popover', '?')"
                          />
                        </label>
                        <VueTelInput
                          name="phone"
                          v-model="teamData.data.attributes.phone"
                          class="tw-h-[50px] tw-m-0 tw-flex tw-text-[#414359] tw-font-['VitoExtended-Light',sans-serif] tw-text-[15px] tw-shadow-none !tw-rounded tw-transition-all tw-duration-200 tw-border !tw-border-[#e6eaed] focus-within:tw-border-2 focus-within:!tw-border-[#0084af] focus-within:!tw-shadow-none hover:!tw-border-[#0084af]"
                          v-validate="{
                            twilio_lookup: twilioLookup,
                          }"
                          :inputOptions="{
                            styleClasses: `tw-m-0 tw-px-[20px] tw-h-full tw-w-full tw-text-[#414359] tw-font-['VitoExtended-Light',sans-serif] tw-text-[15px]`,
                          }"
                          data-vv-validate-on="blur"
                          valid-characters-only
                          @input="updatePhoneObject"
                          aria-describedby="phone-help"
                          v-bind="phoneInputAttrs"
                        />
                        <small
                          v-if="twilioLookupErrorMsg"
                          class="tw-mt-1 tw-text-red-600 tw-font-[700] tw-text-[80%]"
                        >
                          <b-icon-exclamation-circle-fill />
                          {{ twilioLookupErrorMsg }}
                        </small>
                        <b-form-text class="font-weight-bold" id="phone-help">
                          <b-icon-question-circle-fill />
                          {{ $t("dashboard.phone.help", "used for SMS and WhatsApp") }}
                        </b-form-text>
                      </div>
                    </div>
                    <!-- cf start here -->
                    <!-- cField.required is enforced only on the public team signup form; an org user may leave any custom field empty -->
                    <div class="wrapper-options" v-if="hasCustomFields.length > 0">
                      <button
                        type="button"
                        @click="showCustomFileds = !showCustomFileds"
                        class="show-hide-bttn"
                        name="button"
                      >
                        {{
                          !showCustomFileds
                            ? $t("dashboard.add_team_show_custom_fileds", "Show custom fileds")
                            : $t("dashboard.add_team_hide_custom_fileds", "Hide custom fileds")
                        }}
                        <i
                          :class="!showCustomFileds ? 'fa fa-angle-down' : 'fa fa-angle-up'"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                    <div class="tw-contents" v-show="showCustomFileds">
                      <div
                        class="col-12 col-lg-6"
                        v-for="cField in hasCustomFields"
                        :key="cField.key"
                      >
                        <div
                          v-if="['checkbox'].includes(cField.type)"
                          class="tw-flex tw-items-center tw-flex-wrap tw-min-h-full"
                        >
                          <b-form-checkbox
                            v-if="['checkbox'].includes(cField.type)"
                            v-model="teamData.data.attributes.custom_data[cField.key]"
                            :placeholder="$t(cField.placeholder)"
                            :name="`custom_field_${cField.key}`"
                          >
                            <div v-html="$t(cField.label)" />
                          </b-form-checkbox>
                        </div>
                        <div
                          v-if="['multiselect'].includes(cField.type)"
                          class="tw-flex tw-items-center tw-flex-wrap tw-gap-x-4 tw-min-h-full"
                        >
                          <div v-html="$t(cField.label)" />
                          <b-form-checkbox-group
                            v-if="['multiselect'].includes(cField.type)"
                            v-model="teamData.data.attributes.custom_data[cField.key]"
                            :options="getOptions(cField)"
                            :name="`custom_field_${cField.key}`"
                          ></b-form-checkbox-group>
                        </div>
                        <b-form-group v-else class="form-group-custom">
                          <label
                            v-if="['text', 'number', 'ddl'].includes(cField.type)"
                            class="form-unit__label"
                            v-html="$t(cField.label)"
                          />
                          <b-form-input
                            v-if="['text', 'number'].includes(cField.type)"
                            v-model="teamData.data.attributes.custom_data[cField.key]"
                            :type="cField.type"
                            :placeholder="$t(cField.placeholder)"
                            size="lg"
                            :name="`custom_field_${cField.key}`"
                          />
                          <b-form-select
                            v-if="['ddl'].includes(cField.type)"
                            v-model="teamData.data.attributes.custom_data[cField.key]"
                            :options="getOptions(cField)"
                            :placeholder="$t(cField.placeholder)"
                            size="lg"
                            :name="`custom_field_${cField.key}`"
                          />
                        </b-form-group>
                      </div>
                    </div>
                    <!-- cf end here -->
                    <div class="wrapper-options">
                      <button
                        type="button"
                        @click="showOptionalyContact = !showOptionalyContact"
                        class="show-hide-bttn"
                        name="button"
                      >
                        {{
                          !showOptionaly
                            ? $t(
                                "dashboard.add_team_show_optionaly2",
                                "Show additional team contact details"
                              )
                            : $t(
                                "dashboard.add_team_hide_optionaly2",
                                "Hide additional team contact details"
                              )
                        }}
                        <i
                          :class="!showOptionalyContact ? 'fa fa-angle-down' : 'fa fa-angle-up'"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                    <div class="col-12" v-show="showOptionalyContact">
                      <br />
                      <div class="row">
                        <div class="col-12">
                          <b-row>
                            <b-col cols="12" lg="6">
                              <team-extra-data
                                type="email"
                                v-model="teamData.data.attributes.extra_emails"
                              />
                            </b-col>
                            <b-col cols="12" lg="6">
                              <team-extra-data
                                type="phone"
                                v-model="teamData.data.attributes.extra_phones"
                              />
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <br />
                    </div>
                    <div class="wrapper-options">
                      <button
                        type="button"
                        @click="showExtraDataKv = !showExtraDataKv"
                        class="show-hide-bttn"
                        name="button"
                      >
                        {{
                          !showExtraDataKv
                            ? $t("teams.extra_data_kv_show", "Show team extra data")
                            : $t("teams.extra_data_kv_hide", "Hide team extra data")
                        }}
                        <i
                          :class="!showExtraDataKv ? 'fa fa-angle-down' : 'fa fa-angle-up'"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                    <div class="col-12" v-show="showExtraDataKv">
                      <br />
                      <TeamExtraDataKv
                        ref="TeamExtraDataKvRef"
                        v-model="teamData.data.attributes.team_extra_data"
                      />
                      <br />
                    </div>
                    <div class="col-12">
                      <p>
                        <strong>
                          {{ $t("dashboard.team_toggle_settings", "Settings: ") }}
                        </strong>
                      </p>
                    </div>
                    <div class="col-12">
                      <AppSwitchToggle
                        :label="$t('teams.show_switch_label')"
                        v-model="teamData.data.attributes.hidden"
                        :true-value="false"
                        :false-value="true"
                      />
                    </div>
                    <div class="col-12">
                      <AppSwitchToggle
                        :label="
                          $t(
                            'teams.featured_switch_label',
                            'Show Team as featured on the campaign page'
                          )
                        "
                        :description="featuredDescription"
                        v-model="teamData.data.attributes.featured"
                      />
                    </div>
                    <div class="col-12">
                      <AppSwitchToggle
                        :label="$t('teams.percentage_view_switch_label')"
                        v-model="teamData.data.attributes.percentage_view"
                      />
                    </div>
                    <div class="wrapper-options">
                      <button
                        type="button"
                        @click="showOptionalySetting = !showOptionalySetting"
                        class="show-hide-bttn"
                        name="button"
                      >
                        {{
                          !showOptionalySetting
                            ? $t(
                                "dashboard.add_team_show_optionaly3",
                                "Show additional team settings"
                              )
                            : $t(
                                "dashboard.add_team_hide_optionaly3",
                                "Hide additional team settings"
                              )
                        }}
                        <i
                          :class="!showOptionalySetting ? 'fa fa-angle-down' : 'fa fa-angle-up'"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                    <div class="col-6" v-show="showOptionalySetting">
                      <div class="form-group form-unit">
                        <label class="form-unit__label">{{ $t("teams.order") }}</label>
                        <input
                          type="text"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          class="form-control form-unit__input"
                          v-model.number="teamData.data.attributes.sort"
                        />
                      </div>
                    </div>
                    <div class="col-6 col-lg-3" v-show="showOptionalySetting">
                      <div class="color-section form-group form-unit">
                        <h2 class="form-unit__label">{{ $t("edit_campaign.color_title") }}</h2>
                        <div class="color-section__inner">
                          <div class="color-section__unit">
                            <div
                              class="picker-block"
                              @click="pickerToggle"
                              :style="{ backgroundColor: teamData.data.attributes.color }"
                            >
                              <chrome-picker
                                v-show="opened"
                                v-model="teamData.data.attributes.color"
                                @input="updateTeamColor"
                                class="picker"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12" v-show="showOptionalySetting">
                      <div class="form-group form-unit">
                        <label class="form-unit__label" for>{{ $t("teams.group", "Group") }}</label>
                        <input
                          type="text"
                          class="form-control form-unit__input"
                          v-model="teamData.data.attributes.group"
                        />
                        <b-form-text class="font-weight-bold" id="parent-team-help">
                          <b-icon-question-circle-fill></b-icon-question-circle-fill>
                          {{
                            $t(
                              "dashboard.group.help",
                              "this is for an optional feature to put teams in groups (Unidy template only). To use this, please contact your Campaign Manager or Tech Support"
                            )
                          }}
                        </b-form-text>
                      </div>
                    </div>
                    <div class="col-12" v-show="showOptionalySetting">
                      <div class="form-group form-unit">
                        <label class="form-unit__label" for>{{
                          $t("teams.external_id", "External ID")
                        }}</label>
                        <input
                          type="text"
                          class="form-control form-unit__input"
                          v-model="teamData.data.attributes.external_id"
                        />
                        <b-form-text class="font-weight-bold" id="parent-team-help">
                          <b-icon-question-circle-fill></b-icon-question-circle-fill>
                          {{
                            $t(
                              "dashboard.external_id.help",
                              "This is for an optional feature to add an external ID to the team."
                            )
                          }}
                        </b-form-text>
                      </div>
                    </div>
                    <div class="col-12" v-show="showOptionalySetting">
                      <div
                        class="form-group form-unit form-unit--addon form-unit--addon-right date-time-select"
                      >
                        <label class="form-unit__label form-unit__label--upper-sm">{{
                          $t("teams.optional_goal_due_date")
                        }}</label>
                        <div class="form-unit__addon-wrap">
                          <div class="form-unit__addon-icon">
                            <IconDatetime />
                          </div>
                          <datetime
                            input-id="goal-due-date"
                            type="datetime"
                            v-model="goalDueDate"
                            :zone="timeZone"
                            value-zone="UTC"
                            input-class="form-control form-unit__input"
                          />
                          <div
                            v-if="teamData.data.attributes.goal_due_date"
                            class="form-unit__addon-icon form-unit__addon-icon--right form-unit__addon-icon--button"
                          >
                            <b-button
                              @click="teamData.data.attributes.goal_due_date = null"
                              variant="danger"
                            >
                              Clear
                            </b-button>
                          </div>
                        </div>
                        <small
                          v-if="!!goalDueDateError"
                          class="font-weight-bold text-danger form-text"
                        >
                          <b-icon-exclamation-circle />
                          {{ goalDueDateError }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-if="edit" :title="$t('teams.images_tab', 'Images')" lazy>
              <team-images :teamId="Number(teamId)" :edit="edit" />
            </b-tab>
            <b-tab :title="$t('teams.description_tab', 'Description')">
              <div class="row">
                <div class="col-12">
                  <div class="form-group form-unit">
                    <div class="form-unit__label">{{ $t("teams.description") }}</div>

                    <quill-editor
                      v-model="teamData.data.attributes.description"
                      ref="myQuillEditor"
                      :options="editorOption"
                    ></quill-editor>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-if="edit" :title="$t('teams.relations', 'Children teams')">
              <div class="row">
                <div class="col-12">
                  <TeamChildrenForm
                    :team="teamPageList"
                    :campaignId="campaignId"
                    :orgId="orgId"
                    ref="TeamChildrenFormRef"
                    @hasChildren="onHasChildren"
                  />
                </div>
              </div>
            </b-tab>
            <b-tab :title="$t('teams.email_tab', 'Email To Donor')">
              <div class="row">
                <div class="col-12">
                  <div class="form-group form-unit">
                    <label class="form-unit__label">{{
                      $t("teams.paragraph_email", "Custom Paragraph In Email to Donors")
                    }}</label>
                    <textarea
                      class="form-unit__textarea"
                      v-model="teamData.data.attributes.paragraph_email"
                    ></textarea>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab :title="$t('teams.sub_accounts_tab', 'Sub-accounts')">
              <sub-accounts-view
                ref="SubAccountsViewRef"
                :teamId="teamId"
                :reportCampaignId="reportCampaign ? reportCampaign.id : null"
              />
            </b-tab>
            <b-tab v-if="showPagesTab && edit" :title="$t('teams.sefer_torah_pages', 'Pages')" lazy>
              <div class="row">
                <div class="col-12">
                  <team-page-list :team="teamPageList" orgarea />
                </div>
              </div>
            </b-tab>
            <b-tab
              v-if="showPinnedDonations"
              :title="$t('teams.pinned_donations', 'Pinned Donations')"
              lazy
            >
              <div class="row">
                <div class="col-12">
                  <TeamPinnedDonations
                    ref="TeamPinnedDonationsRef"
                    :team="teamPageList"
                    :campaignId="campaignId"
                    :orgId="orgId"
                  />
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </form>
    </b-modal>
    <MediaStorageCropperModal :campaignTemplate="campaignTemplate" ref="MediaStorageCropperModal" />
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import Chrome from "vue-color/src/components/Chrome.vue";
import ClickOutside from "vue-click-outside";
import MultiselectSearch from "@/components/multiselect-search.vue";
import { BIconQuestionCircleFill } from "bootstrap-vue";
import subAccountsView from "@/components/subAccountsView.vue";
import urls from "@/constants/urls.js";
import error from "@/components/errors.vue";
import { notificationsMixin } from "@/mixins";
import teamExtraData from "./team-extra-data.vue";
import TeamExtraDataKv from "./team-extra-data-kv.vue";
import teamImages from "./team-images.vue";
import MediaStorageCropperModal from "@/views/media-storage/MediaStorageCropperModal.vue";
import TeamGoalCategories from "./team-goal-categories.vue";
import TeamPageList from "@/views/donor-dashboard/sefer-torah/team-page-list.vue";
import AppSwitchToggle from "@/common-components/ui-elements/app-switch-toggle.vue";
import { unwrapContentValue } from "@/components/vue-quill-editor/utils";
import TeamPinnedDonations from "@/views/campaigns/campaign-edit-vue/subcomponents/team-pinned-donations.vue";
import CustomVideo from "@/components/vue-quill-editor/formats/custom-video";
import IconDatetime from "@/components/icon-datetime.vue";
import { VueTelInput } from "vue-tel-input";
import { defineComponent } from "vue";
import TeamChildrenForm from "./team-children-form.vue";

// mirrors the backend slugifyTeamName: lowercase alphanumerics only, runs of
// anything else collapse to a single hyphen
const slugifyTeamName = (name) =>
  (name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const useGoalModel = (key) => ({
  get() {
    if (this.currencyRate === 1) {
      return this.teamData.data.attributes[key];
    }
    return this.teamData.data.attributes[`display_${key}_currency_amount`];
  },
  set(val) {
    if (!Number.isNaN(Number(val))) {
      if (this.currencyRate === 1) {
        this.teamData.data.attributes[key] = Number(val);
        this.teamData.data.attributes[`display_${key}_currency_amount`] = 0;
      } else {
        this.teamData.data.attributes[key] = Math.ceil(Number(val) * this.currencyRate);
        this.teamData.data.attributes[`display_${key}_currency_amount`] = Number(val);
        this.teamData.data.attributes["display_to_campaign_currency_rate"] = this.currencyRate;
      }
    } else {
      this.teamData.data.attributes[key] = val;
    }
  },
});

export default defineComponent({
  components: {
    error: error,
    chromePicker: Chrome,
    MultiselectSearch,
    BIconQuestionCircleFill,
    subAccountsView,
    teamImages,
    teamExtraData,
    TeamExtraDataKv,
    MediaStorageCropperModal,
    TeamGoalCategories,
    TeamPageList,
    AppSwitchToggle,
    TeamPinnedDonations,
    IconDatetime,
    VueTelInput,
    TeamChildrenForm,
  },
  props: {
    dashboard: {
      default: false,
    },
    reportCampaign: {
      default: null,
      type: Object,
    },
    currentpage: {
      default: 1,
    },
    searchvalue: {
      default: "",
    },
    shortlink: {
      default: "",
    },
    ccy: {
      default: "",
    },
    defaultTeamAvatarSrc: {
      type: String,
      default: "",
    },
    hideAddButton: Boolean,
  },
  mixins: [notificationsMixin],
  data() {
    return {
      opened: false,
      sending: false,
      errors: false,
      edit: false,
      teamId: 0,
      hasChildren: false,
      parentTeamId: null,
      parentTeamId2: null,
      activeTeamRequestId: 0,
      teamData: {
        data: {
          attributes: {
            campaign_id: 0,
            parent_team_id: 0,
            parent_team_id2: 0,
            name: "",
            slug: "",
            description: "",
            goal: 0,
            bonus_goal: 0,
            internal_goal: 0,
            display_goal_currency: "",
            display_goal_currency_amount: 0,
            display_bonus_goal_currency_amount: 0,
            display_internal_goal_currency_amount: 0,
            donor_goal: 0,
            color: "",
            custom_data: {},
            image: "",
            sort: 1,
            paragraph_email: "",
            leader_name: "",
            leader_email: "",
            phone: "",
            custom_link: "",
            extra_emails: [],
            extra_phones: [],
            goal_categories: [],
            goal_due_date: 0,
            external_id: "",
            team_extra_data: [],
          },
        },
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "underline", "strike", "italic"],
              ["blockquote"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ align: [] }],
              [{ color: [] }, { background: [] }],
              ["image"],
              [CustomVideo.blotName],
              ["link"],
              ["clean"],
            ],
          },
        },
      },
      currencyRate: 1,
      showOptionaly: false,
      showOptionalyContact: false,
      showOptionalySetting: false,
      showExtraDataKv: false,
      goalDueDateError: "",
      phoneObject: null,
      showCustomFileds: false,
      savedCurrencyRate: {},
      defaultAvatarManuallyCleared: false,
      slugManuallySet: false,
    };
  },

  directives: {
    ClickOutside,
  },

  computed: {
    ...mapState({
      campaignRounds: (state) => {
        return state.campaign.campaign.data.attributes.rounds;
      },

      timeZone: (state) => {
        return state.account.account.data.attributes.timezone;
      },

      campaignId(state) {
        return (
          (this.reportCampaign && this.reportCampaign.id) ||
          (this.dashboard && state.dashboard.selectedCampaign) ||
          state.campaign.campaign.data.id
        );
      },

      dashboardCmp(state) {
        if (this.dashboard) {
          return state.campaigns.campaigns.find((el) => el.id === this.campaignId);
        }

        return false;
      },

      campaignTemplate(s) {
        if (this.reportCampaign) {
          return this.reportCampaign.attributes.template;
        }

        return s.campaign.campaign.data.attributes.template;
      },

      shortUrl(state) {
        if (this.dashboard) {
          return this.dashboardCmp.attributes.short_url;
        }
        if (state.campaign?.campaign?.data) {
          return state.campaign.campaign.data.attributes.short_url;
        }
        if (this.reportCampaign) {
          return this.reportCampaign.attributes.short_url;
        }
      },

      campaignEndDate(state) {
        if (this.dashboard) {
          return this.dashboardCmp.attributes.end_date;
        }
        if (state.campaign?.campaign?.data) {
          return state.campaign.campaign.data.attributes.end_date;
        }
        if (this.reportCampaign) {
          return this.reportCampaign.attributes.end_date;
        }
      },

      orgId() {
        return localStorage.getItem("orgId");
      },

      hasAccessEdit: (s) => s.account.access.CanEditCampaignTeams,
      hasAccessAdd: (s) => s.account.access.CanAddCampaignTeams,
      hasAccessAddCustomLinkToTeam: (s) => s.account.addCustomLinkToTeam,

      metas: (state) => state.campaign.metas,
      multiple_team_parent() {
        const meta = this.metas["multiple_team_parent"] || {};
        return meta.value || false;
      },
      featured_teams() {
        const meta = this.metas["featured_teams"] || {};
        return meta.value || false;
      },
      hasCustomFields() {
        const meta = this.metas["view_team_form_custom_fields"] || {};
        if (meta.value && meta?.fields?.length > 0) {
          return meta.fields || [];
        }
        return [];
      },
      showPagesTab: (s) => s.seferTorahPages.active,
      currencies: (s) => s.account.currencyList?.map((el) => el.attributes.code) || [],
      showPinnedDonations: (s) => s.featureHide.showPinnedDonations,
      defaultCountry: (s) => s.account.userCountry,
    }),

    getTeamSearchUrl() {
      const cID = this.campaignId;
      const orgID = this.orgId;

      if (Number(cID) === 0) {
        throw new Error("getTeamSearchUrl team form parent picker campaign id is 0");
      }

      return urls.apiTeams.replace(":orgId", orgID).replace(":campaignId", cID);
    },

    teamSearchOptions() {
      return {
        placeholder: this.$t("dashboard.select_parent_team"),
        changeParams: ({ query, page, per_page: pp }) => ({
          q: query,
          page: page,
          limit: pp,
        }),
        customLabel: (e) => `[${e.id}] ${e.name}`,
        processResults: (data) =>
          data.map((el) => ({
            id: el.id,
            ...el.attributes,
          })),
      };
    },

    teamSearchOptions2() {
      return {
        ...this.teamSearchOptions,
        placeholder: this.$t("dashboard.select_parent_team_2"),
      };
    },

    goalDueDate: {
      get() {
        if (!this.teamData.data.attributes.goal_due_date) {
          return "";
        }
        return new Date(this.teamData.data.attributes.goal_due_date * 1000).toISOString();
      },
      set(val) {
        if (val === "") {
          this.goalDueDateError = "";
          this.teamData.data.attributes.goal_due_date = null;
          return;
        }

        const date = new Date(val).getTime() / 1000;
        if (date > this.campaignEndDate) {
          this.teamData.data.attributes.goal_due_date = null;
          this.goalDueDateError = this.$t(
            "edit_campaign.generalinfo_goal_due_date_error",
            "goal due date cannot be after campaign expiration date"
          );
          return;
        }

        this.goalDueDateError = "";
        this.teamData.data.attributes.goal_due_date = date;
      },
    },

    teamPageList() {
      return {
        id: Number(this.teamId),
        ...this.teamData.data.attributes,
      };
    },

    teamLink() {
      if (this.shortUrl) {
        return `https://${this.shortUrl}/${this.teamData.data.attributes.slug}`;
      }
      return `https://www.charidy.com/${this.shortlink}/${this.teamData.data.attributes.slug}`;
    },
    domain() {
      if (this.shortUrl) {
        return `${this.shortUrl}`;
      }

      return `https://www.charidy.com/${this.campaignShortLink}`;
    },

    displayGoalCurrencyModel: {
      get() {
        return this.teamData.data.attributes.display_goal_currency;
      },
      set(val) {
        this.teamData.data.attributes.display_goal_currency = val.toLowerCase();
      },
    },

    displayGoalCurrencyAmountModel: useGoalModel("goal"),
    displayBonusGoalCurrencyAmountModel: useGoalModel("bonus_goal"),
    displayInternalGoalCurrencyAmountModel: useGoalModel("internal_goal"),

    goalInCampaignCurrency() {
      return this.teamData.data.attributes.goal;
    },
    bonusGoalInCampaignCurrency() {
      return this.teamData.data.attributes.bonus_goal;
    },
    internalGoalInCampaignCurrency() {
      return this.teamData.data.attributes.internal_goal;
    },
    phoneInputAttrs() {
      if (!this.edit || !this.teamData.data.attributes.phone) {
        return {
          defaultCountry: this.defaultCountry,
          autoDefaultCountry: this.autoDefaultCountry,
          mode: "international",
        };
      } else {
        return {
          defaultCountry: "",
          autoDefaultCountry: false,
          mode: "international",
          ...(!this.phoneObject?.valid
            ? {
                dropdownOptions: {
                  showFlags: false,
                },
              }
            : {}),
        };
      }
    },
    autoDefaultCountry() {
      return this.defaultCountry === "N/A" || this.defaultCountry.length === 0;
    },
    twilioLookupErrorMsg() {
      if (this.vErrorsHas("phone", "twilio_lookup")) {
        return this.$t("template.field_error_twilio_lookup", "Invalid or incorrect phone number");
      }

      if (this.vErrorsHas("phone", "phone_number")) {
        return this.$t("template.field_error_phone_number", "Invalid or incorrect phone number");
      }

      return "";
    },
    twilioLookup() {
      return {
        valid: this.phoneObject?.number?.length >= 10,
      };
    },
    displayTeamImage() {
      return this.teamData?.data?.attributes?.image || "";
    },

    featuredDescription() {
      return this.$t(
        "teams.featured_switch_description",
        `Shows the team on the campaign page as a featured team. To enable please activate <a href='/campaign/${this.campaignId}#settings?setting=featured_teams' target='_blank'>Featured Teams</a> in the campaign settings.`
      );
    },

    roundsInfo() {
      const rounds = Array.isArray(this.campaignRounds)
        ? JSON.parse(JSON.stringify(this.campaignRounds))
        : [];

      if (rounds.length < 2) {
        rounds.push({
          goal: 0,
          multiplier: 0,
          round: 1,
        });
      }

      return {
        primary_goal_multiplier: Number(rounds?.[0]?.multiplier) || 1,
        bonus_goal_multiplier: Number(rounds?.[1]?.multiplier) || 0,
      };
    },

    pgMultiplier() {
      return this.roundsInfo.primary_goal_multiplier;
    },

    bgMultiplier() {
      return this.roundsInfo.bonus_goal_multiplier;
    },
  },

  watch: {
    hasCustomFields: {
      handler(list) {
        list.forEach((f) => this.setDefaultValue(f));
      },
      immediate: true,
    },
    "teamData.data.attributes.name"(name) {
      // keep the shortlink in sync with the name for new teams until the user
      // types their own shortlink or generates a random one
      if (this.edit || this.slugManuallySet) {
        return;
      }
      this.teamData.data.attributes.slug = slugifyTeamName(name);
    },
    parentTeamId() {
      if (this.parentTeamId) {
        this.teamData.data.attributes.parent_team_id = parseInt(this.parentTeamId.id);
      } else {
        this.teamData.data.attributes.parent_team_id = 0;
      }
    },
    parentTeamId2() {
      if (this.parentTeamId2) {
        this.teamData.data.attributes.parent_team_id2 = parseInt(this.parentTeamId2.id);
      } else {
        this.teamData.data.attributes.parent_team_id2 = 0;
      }
    },
    currencyRate() {
      const attrs = this.teamData.data.attributes;

      this.displayGoalCurrencyAmountModel =
        attrs.display_goal_currency_amount || this.goalInCampaignCurrency;
      this.displayBonusGoalCurrencyAmountModel =
        attrs.display_bonus_goal_currency_amount || this.bonusGoalInCampaignCurrency;
      this.displayInternalGoalCurrencyAmountModel =
        attrs.display_internal_goal_currency_amount || this.internalGoalInCampaignCurrency;
    },
  },

  methods: {
    setDefaultValue(f) {
      if (["checkbox"].includes(f.type) && !this.edit) {
        this.$set(this.teamData.data.attributes.custom_data, f.key, f.checked);
      } else if (["multiselect"].includes(f.type)) {
        this.$set(this.teamData.data.attributes.custom_data, f.key, []);
      } else {
        this.$set(this.teamData.data.attributes.custom_data, f.key, null);
      }
    },
    getOptions(f) {
      if (!f.options) return [];

      // fallback for array of strings
      if (Array.isArray(f.options)) {
        return f.options.map((el) =>
          typeof el === "string"
            ? this.$t(el)
            : {
                ...el,
                text: this.$t(el.text),
              }
        );
      }

      // map[string]string
      return Object.entries(f.options).map(([key, value]) => ({
        value: key,
        text: this.$t(value),
      }));
    },

    onHasChildren(hasChildren) {
      this.hasChildren = hasChildren;
    },

    updateCurrency(val) {
      this.displayGoalCurrencyModel = val;
      this.xchange();
    },

    onSlugInput(e) {
      // clearing the field hands the shortlink back to the name sync
      this.slugManuallySet = e.target.value !== "";
    },

    generateRandomSlug() {
      this.slugManuallySet = true;
      this.teamData.data.attributes.slug = String(100000 + Math.floor(Math.random() * 900000));
    },

    copySlug() {
      navigator.clipboard.writeText(this.teamLink).then(() => {
        this.$bvToast.toast(this.$t("teams.copy_slug_content"), {
          title: this.$t("teams.copy_slug_title"),
          variant: "success",
        });
      });
    },

    pickerToggle() {
      this.opened = true;
    },

    hidePickerColor(e) {
      if (!e.target.closest(".picker-block")) {
        this.opened = false;
      }
    },

    updateTeamColor(color) {
      this.teamData.data.attributes.color = color.hex8;
    },

    openModal() {
      this.updateCurrency(this.ccy);
      this.applyDefaultTeamAvatarIfNeeded();
      this.$root.$emit("bv::show::modal", "team-form");
    },

    openEditModal(team) {
      this.edit = true;
      this.hasChildren = true;
      this.teamId = team.id;
      const cloned = JSON.parse(JSON.stringify(team.attributes));
      if (!Array.isArray(cloned.team_extra_data)) cloned.team_extra_data = [];
      this.teamData.data.attributes = cloned;
      this.applyDefaultTeamAvatarIfNeeded();

      if (this.teamData.data.attributes.display_goal_currency) {
        this.savedCurrencyRate = {
          [this.teamData.data.attributes.display_goal_currency]:
            this.teamData.data.attributes.display_to_campaign_currency_rate,
        };
      }

      this.$root.$emit("bv::show::modal", "team-form");

      this.setActiveTeam();
      this.updateCurrency(team.attributes.display_goal_currency || this.ccy);
    },

    async openEditModalWithId(teamId) {
      this.edit = true;
      this.teamId = teamId;

      const team = await this.getTeam(teamId);
      const cloned = JSON.parse(JSON.stringify(team.data.attributes));
      if (!Array.isArray(cloned.team_extra_data)) cloned.team_extra_data = [];
      this.teamData.data.attributes = cloned;
      this.applyDefaultTeamAvatarIfNeeded();

      if (this.teamData.data.attributes.display_goal_currency) {
        this.savedCurrencyRate = {
          [this.teamData.data.attributes.display_goal_currency]:
            this.teamData.data.attributes.display_to_campaign_currency_rate,
        };
      }

      this.$root.$emit("bv::show::modal", "team-form");

      this.setActiveTeam();
      this.updateCurrency(team.data.attributes.display_goal_currency || this.ccy);
    },

    setActiveTeam() {
      const parentTeamId = this.teamData.data.attributes.parent_team_id;
      const parentTeamId2 = this.teamData.data.attributes.parent_team_id2;
      const ids = [parentTeamId, parentTeamId2].filter(Boolean);

      this.activeTeamRequestId += 1;
      const requestId = this.activeTeamRequestId;

      if (!ids.length) {
        this.parentTeamId = null;
        this.parentTeamId2 = null;
        return;
      }

      axios
        .get(this.getTeamSearchUrl, { params: { team_id: ids, limit: ids.length } })
        .then(({ data }) => {
          // Drop the response if the modal was reopened for another team (or closed/reset)
          // while this request was in flight.
          if (requestId !== this.activeTeamRequestId) {
            return;
          }
          const teams = this.teamSearchOptions.processResults(data.data);
          this.parentTeamId = teams.find((t) => Number(t.id) === Number(parentTeamId)) || null;
          this.parentTeamId2 = teams.find((t) => Number(t.id) === Number(parentTeamId2)) || null;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    clearData() {
      this.edit = false;
      this.sending = false;
      this.showCustomFileds = false;

      this.teamData.data.attributes = {
        campaign_id: 0,
        parent_team_id: 0,
        parent_team_id2: 0,
        name: "",
        slug: "",
        description: "",
        goal: 0,
        internal_goal: 0,
        donor_goal: 0,
        bonus_goal: 0,
        display_goal_currency: "",
        display_goal_currency_amount: 0,
        display_bonus_goal_currency_amount: 0,
        display_internal_goal_currency_amount: 0,
        color: "",
        custom_data: {},
        image: "",
        sort: 0,
        paragraph_email: "",
        leader_name: "",
        leader_email: "",
        phone: "",
        custom_link: "",
        extra_emails: [],
        extra_phones: [],
        goal_categories: [],
        team_extra_data: [],
      };

      this.teamId = 0;
      this.hasChildren = false;
      this.parentTeamId = null;
      this.parentTeamId2 = null;
      this.activeTeamRequestId += 1;
      this.currencyRate = 1;
      this.savedCurrencyRate = {};
      this.defaultAvatarManuallyCleared = false;
      this.slugManuallySet = false;

      this.$validator.reset();
    },

    modalClose() {
      this.sending = false;
      this.$root.$emit("bv::hide::modal", "team-form");
    },

    saveForm() {
      this.sending = false;
      this.showCustomFileds = true;
      this.$validator.validate().then((valid) => {
        const extraDataValid = this.$refs.TeamExtraDataKvRef
          ? this.$refs.TeamExtraDataKvRef.validate()
          : true;
        if (!extraDataValid) {
          this.showExtraDataKv = true;
        }
        if (!valid || !extraDataValid) {
          for (let i = 0; i < this.$validator.errors.items.length; i++) {
            this.$_notificationsMixin_makeToast(
              "Error!",
              this.$t("template.field_error", this.$validator.errors.items[i].msg),
              "danger"
            );
          }
          if (!extraDataValid) {
            this.$_notificationsMixin_makeToast(
              "Error!",
              this.$t(
                "teams.extra_data_kv_validation_error",
                "Team extra data has invalid entries"
              ),
              "danger"
            );
          }
          return;
        }

        if (this.edit) {
          this.editTeam()
            .then(() => {
              this.getCampaignById();
            })
            .then(this.$refs?.TeamPinnedDonationsRef?.$saveSelectedPinnedDonations)
            .then(this.$refs?.SubAccountsViewRef?.$createAndEdit)
            .then(this.$refs?.TeamChildrenFormRef?.$save)
            .then(() => {
              this.$_notificationsMixin_makeToast(
                "Success!",
                this.$t("edit_campaign.success_edit"),
                "success"
              );
              this.modalClose();
            });

          return;
        }

        this.addNewTeam();
      });
    },

    getCampaignById() {
      const params = {
        page: this.currentpage,
        limit: 50,
        q: this.searchvalue,
        extend: ["stats"],
      };

      return this.$store.dispatch("getTeamsByCampaignId", [this.campaignId, params]);
    },

    formatData() {
      const attrs = this.teamData.data.attributes;

      attrs.campaign_id = Number(this.campaignId);
      attrs.description = unwrapContentValue(attrs.description);
      attrs.sort = Number(attrs.sort) || 0;
      attrs.bonus_goal = Number(attrs.bonus_goal) || 0;
      attrs.extra_emails = attrs.extra_emails?.filter((e) => e) || [];
      attrs.extra_phones = attrs.extra_phones?.filter((e) => e) || [];
      attrs.team_extra_data = (attrs.team_extra_data || [])
        .filter((row) => row && (row.key || "").trim() !== "")
        .map((row) => ({ key: String(row.key).trim(), value: String(row.value ?? "") }));
      attrs.phone = this.phoneObject?.valid ? this.phoneObject?.number : attrs.phone;

      this.teamData.data.attributes = attrs;
    },

    addNewTeam() {
      this.sending = true;
      this.errors = [];

      this.formatData();

      if (Number(this.campaignId) === 0) {
        throw new Error("addNewTeam campaign id is 0");
      }

      return axios
        .post(
          urls.apiTeams.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId),
          this.teamData
        )
        .then((res) => {
          this.$_notificationsMixin_makeToast(
            "Success!",
            this.$t("edit_campaign.success_edit"),
            "success"
          );

          const warnings = res?.data?.data?.attributes?.warnings;
          if (warnings && warnings.length) {
            warnings.forEach((w) => {
              this.$_notificationsMixin_makeToast("Warning", w, "warning");
            });
          }

          const params = {
            page: this.currentpage,
            limit: 50,
            q: this.searchvalue,
            extend: ["stats"],
          };
          this.$store.dispatch("getTeamsByCampaignId", [this.campaignId, params]);

          this.modalClose();
        })
        .catch((e) => {
          this.$_notificationsMixin_handleCatch(e);
          throw e;
        })
        .finally(() => (this.sending = false));
    },

    editTeam() {
      this.sending = true;
      this.errors = [];

      this.formatData();

      return axios
        .put(
          urls.editTeams.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId) +
            "/" +
            this.teamId,
          this.teamData
        )
        .catch((e) => {
          this.$_notificationsMixin_handleCatch(e);
          throw e;
        })
        .finally(() => (this.sending = false));
    },

    getTeam(teamId) {
      return axios
        .get(
          urls.editTeams.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId) +
            "/" +
            teamId
        )
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          this.$_notificationsMixin_handleCatch(e);
          throw e;
        });
    },

    deleteImage() {
      this.defaultAvatarManuallyCleared = true;
      this.teamData.data.attributes.image = "";
    },

    applyDefaultTeamAvatarIfNeeded() {
      if (this.defaultAvatarManuallyCleared) {
        return;
      }

      if (!this.teamData.data.attributes.image && this.defaultTeamAvatarSrc) {
        this.teamData.data.attributes.image = this.defaultTeamAvatarSrc;
      }
    },

    changeImage() {
      this.load = true;

      this.errors = [];

      let fileInput = document.createElement("input");
      fileInput.setAttribute("type", "file");
      fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon");
      fileInput.classList.add("load-image-input");

      fileInput.addEventListener("change", () => {
        if (fileInput.files != null && fileInput.files[0] != null) {
          this.$refs.MediaStorageCropperModal.open({
            file: fileInput.files[0],
            tag: "team_default_avatar",
          });
          this.$refs.MediaStorageCropperModal.onOK((blob) => {
            let form_data = new FormData();
            form_data.append("file", blob);

            axios
              .post(urls.loadImageQuill.replace(":OrgId", this.orgId), form_data)
              .then((response) => {
                this.load = false;

                this.teamData.data.attributes.image = response.data.src;

                fileInput.remove();
              })
              .catch((e) => {
                this.load = false;
                if (e.response.data) {
                  if (e.response.data.error) {
                    this.errors.push(e.response.data.error);
                  } else {
                    this.errors.push(this.$t("template.error_default"));
                  }
                } else {
                  this.errors.push(this.$t("template.error_default"));
                }
              });
          });
        }
      });

      document.querySelector("body").appendChild(fileInput);

      fileInput.click();
    },

    onActivateTab(/* newTabIndex, prevTabIndex, bvEvent */) {
      // TODO: try catch not working when field is not visible
      // const formValid = this.$refs.TeamAdd.reportValidity();
      // if (!formValid) {
      //   bvEvent.preventDefault();
      // }
    },

    xchange() {
      if (this.displayGoalCurrencyModel === this.ccy) {
        this.currencyRate = 1;
        return;
      }

      if (
        this.savedCurrencyRate[this.displayGoalCurrencyModel] &&
        this.savedCurrencyRate[this.displayGoalCurrencyModel] > 0
      ) {
        this.currencyRate = this.savedCurrencyRate[this.displayGoalCurrencyModel];
        return;
      }

      return axios
        .get(
          urls.getConversionAmount
            .replace(":amount", 1)
            .replace(":from", this.displayGoalCurrencyModel)
            .replace(":to", this.ccy)
        )
        .then(({ data }) => {
          this.currencyRate = Math.round(data.data.attributes.amount_out * 100) / 100;
        });
    },

    updatePhoneObject(_, phoneObject) {
      this.phoneObject = phoneObject;
    },
    vErrorsHas(field, rule) {
      return this.vErrors.items.find((el) => el.field === field && el.rule === rule);
    },
  },
});
</script>

<style lang="scss">
.quill-editor .ql-container {
  height: 200px;
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  background: #fff;
}

.ql-toolbar.ql-snow {
  background: #fff;
}

.form-unit__copy-link:not([href]) {
  cursor: pointer;
  color: $bb-70;
  overflow-wrap: break-word;
  &:hover {
    text-decoration: underline;
    color: $bb-70;
  }
}

#team-form {
  .form-unit__addon-wide {
    justify-content: flex-start;
    width: 65%;
    max-width: 65%;
    font-size: 16px;
    text-transform: none;
    overflow: hidden;
    overflow-x: auto;
  }
  .form-unit__input--slug {
    width: 35%;
    margin-bottom: 10px;
  }
  .ql-editor {
    font-family: "ProximaNova-Regular";
    font-size: 16px;
    strong {
      font-family: "ProximaNova-Bold";
    }
  }
  .form-unit__textarea {
    font-family: "ProximaNova-Regular";
    font-size: 16px;
  }
  .no-pointer {
    cursor: default !important;
  }
}

.form-unit__label {
  display: inline-block;
}

.color-section {
  margin-bottom: 40px;
  &__inner {
    display: flex;
  }
  &__unit {
    width: 300px;
  }
}
.picker-block {
  height: 50px;
  width: 100%;
  margin: 0;
  padding: 0 20px;
  display: block;
  color: #20434e;
  font-size: 16px;
  font-weight: 600;
  border: 1px solid rgba(32, 67, 78, 0.15);
  box-shadow: none;
  border-radius: 4px;
  transition: all 0.2s;
  position: relative;
  cursor: pointer;
  .picker {
    display: block;
  }
}

.picker {
  display: none;
  position: absolute;
  top: 102%;
  left: 0;
  z-index: 2;
}

.convert-amount {
  padding: 0 15px;
  display: flex;
  align-items: center;
  label {
    white-space: nowrap;
    margin: 0;
    text-transform: uppercase;
  }
}
</style>
